

import React from "react"
import Logo from "./assests/Logo.png"
import { Facebook, Linkedin, Youtube, Twitter } from "lucide-react"

const Footer = ({ openLinkInIframe }) => {
  const navItems = [
   
    {
      name: `Terms & Conditions`,
       href: `/terms-and-conditions-by-alphaquark`,
    },
    {
      name: "Privacy Policy",
      href: `/privacy-policy`,
    },
    { name: "Disclaimer", href: `/disclaimer` },

    {
      name: "Refund Policy",
      href: `/refund-policy`,
    },
    // {
    //   name: "Investors Awareness",
    //   href: `/investors-awareness`,
    // },
    // {
    //   name: "Grievance Redressal",
    //   href: `/grievance-redressal`,
    // },
    {
      name: "Contact Us",
      href: `/contact-us`,
    },
  ]


  const socialLinks = [
    {
      name: "Facebook",
      href: "",
      icon: <Facebook size={28} className="text-white hover:text-yellow-400 transition-colors" />,
    },
    // {
    //   name: "Instagram",
    //   href: "",
    //   icon: <Instagram size={28} className="text-white hover:text-yellow-400 transition-colors" />
    // },
    // {
    //   name: "LinkedIn",
    //   href: "https://www.linkedin.com/company/mtm-masterthemarket/",
    //   icon: <Linkedin size={28} className="text-white hover:text-yellow-400 transition-colors" />
    // },
    {
      name: "LinkedIn",
      href: "",
      icon: <Linkedin size={28} className="text-white hover:text-yellow-400 transition-colors" />,
    },
    {
      name: "Twitter",
      href: "",
      icon: <Twitter size={28} className="text-white hover:text-yellow-400 transition-colors" />,
    },
    {
      name: "YouTube",
      href: "",
      icon: <Youtube size={28} className="text-white hover:text-yellow-400 transition-colors" />,
    },
  ]

  return (
    <footer className="bg-black " id="footer">
      <div className="max-w-7xl mx-auto px-4">
        {/* Logo */}
        <div className="flex justify-center py-4">
          <img
            src={Logo || "/placeholder.svg"}
            alt="Master The Market Logo"
            className="w-32 h-w-32 object-contain rounded-md"
          />
          {/* <h2 className="text-white text-2xl md:text-2xl font-neo-sans">
            PHD<span className="font-bold text-white">Capital</span>
          </h2> */}
        </div>

        {/* Address and Contact */}
        {/* <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2 text-white">
            <MapPin size={16} className="text-[#4CC7B1]" />
            <span className="text-sm"> Plot no.126/127, Scheme no. 113, Vijay Nagar, Indore, 452010</span>
          </div>
          <div className="flex items-center gap-2 text-white">
            <Phone size={16} className="text-[#4CC7B1]" />
            <span className="text-sm">+91 6268426713</span>
          </div>
        </div> */}

        {/* Navigation - Responsive: Grid on mobile, Flex on desktop */}
        <nav className="mb-8">
          {/* Mobile Navigation */}
          <div className="grid grid-cols-1 gap-4 md:hidden">
            {navItems.map((item) => (
              <a
                key={item.name}
                onClick={() => openLinkInIframe(item.name, item.href)}
                className="text-white hover:text-yellow-400 transition-colors font-normal font-poppins text-sm text-center capitalize cursor-pointer"
              >
                {item.name}
              </a>
            ))}
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex justify-center items-center overflow-x-auto whitespace-nowrap py-2">
            {navItems.map((item, index) => (
              <React.Fragment key={item.name}>
                <a
                  onClick={() => openLinkInIframe(item.name, item.href)}
                  className="text-white hover:text-yellow-400 transition-colors font-normal font-poppins text-sm px-3 capitalize cursor-pointer"
                >
                  {item.name}
                </a>
                {index < navItems.length - 1 && <span className="text-white">|</span>}
              </React.Fragment>
            ))}
          </div>
        </nav>

        {/* Social Media Icons */}
        <div className="flex justify-center items-center space-x-8 mb-8">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.name}
              className="hover:scale-110 transition-transform"
            >
              {social.icon}
            </a>
          ))}
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-gray-700 my-6"></div>

        {/* Copyright */}
        <div className="text-center text-white ">
          <p className="flex flex-col md:flex-row items-center justify-center md:gap-6">
          <span className="mb-4">Copyright©2025 Market Analysis Academy All Right Reserved</span>
            {/* <span className="hidden md:inline">|</span> */}
            {/*<span>*/}
            {/*  Made with <span className="text-red-500">❤️</span> by Alphaquark*/}
            {/*</span>*/}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer

